import { component } from "picoapp";

export default component(async (node) => {
  const [
    { default: KeenSlider },
    { useFade, useAutoPlay, useNav, useAriaHidden },
  ] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const fullImageSliderContainer = node.querySelector(
    "[data-keen-slider-full-image]"
  );
  const textSliderContainer = node.querySelector("[data-keen-slider-text]");
  const nextImageSliderContainer = node.querySelector(
    "[data-keen-slider-next-image]"
  );

  const slideIndex = textSliderContainer.querySelector(
    "[data-about-slider-index]"
  );
  const timer = node.querySelector("[data-about-slider-timer]");

  const textSlider = KeenSlider(
    textSliderContainer,
    {
      loop: true,
      drag: false,
      useAutoPlay: {
        duration: 3000,
      },
      useFade: {
        duration: "0.3s",
        timingFunction: "linear",
      },
      created: () => {
        textSliderContainer.classList.remove("hide-init");
      },
      slideChanged: (instance) => {
        const index = instance.track.details.rel;
        const j = index + 1;
        slideIndex.innerHTML = j;
        timer.classList.remove("timer--animated");
        // eslint-disable-next-line no-void
        void timer.offsetWidth;
        timer.classList.add("timer--animated");
      },
    },
    [useFade, useAriaHidden]
  );

  const nextSlider = KeenSlider(
    nextImageSliderContainer,
    {
      loop: true,
      drag: false,
      useFade: {
        duration: "0.3s",
        timingFunction: "linear",
      },
      created: () => {
        nextImageSliderContainer.classList.remove("hide-init");
      },
    },
    [useFade, useNav(textSlider), useAriaHidden]
  );

  const fullImageSlider = KeenSlider(
    fullImageSliderContainer,
    {
      loop: true,
      drag: false,
      useFade: {
        duration: "0.3s",
        timingFunction: "linear",
      },
      useAutoPlay: {
        duration: 8000,
        buttonClass: "play-control",
        srStopButtonLabel: "Pause carousel rotation",
        srPlayButtonLabel: "Resume carousel rotation",
        srPresentation: true,
      },
      created: () => {
        fullImageSliderContainer.classList.remove("hide-init");
      },
    },
    [useFade, useAutoPlay, useNav(nextSlider), useAriaHidden]
  );

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        fullImageSlider.emit("play");
        timer.classList.remove("timer--animated");
        // eslint-disable-next-line no-void
        void timer.offsetWidth;
        timer.classList.add("timer--animated");
      } else {
        fullImageSlider.emit("stop");
      }
    });
  });

  observer.observe(node);
});
